import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useReducer, useRef } from "react";

const ModalStringList = (props) => {
    const ulList = useRef();
    const { popData, setPopData } = props;
    const { show, title, stringList, size } = popData;
    let showList = [];
    if (stringList) {
        if (Array.isArray(stringList)) {
            showList = stringList;
        }
        else if (stringList.includes(",")) {
            showList = stringList.split(",");
        }
    }
    function close() {
        setPopData({
            show: false
        })
    }
    useEffect(()=>{
        if (show) {
            document.documentElement.style.overflow = "hidden";
        }
        else {
            document.documentElement.style.overflow = "unset";
        }
    },[show])
    return (
        <Modal show={show} onHide={() => { }} size={size??"sm"}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faListAlt} size="lg" />
                    &nbsp;
                    {title}</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{padding:"3px", borderBottom:"3px solid #bb1370cc"}}>
                {showList && Array.isArray(showList) &&
                    <div className="scThin" style={{ overflow: "auto", maxHeight: "350px" }}>
                        <ul ref={ulList}>
                            {showList.map((s, i) =>
                                <li key={i} style={{padding:"6px", borderBottom:"1px solid #9a9af1", color:"#2f2f76"}}>{s}</li>
                            )}
                        </ul>
                    </div>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalStringList;